/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Írjon be valamit',
	Advanced: 'Haladó',
	'About Jodit': 'Joditról',
	'Jodit Editor': 'Jodit Editor',
	'Free Non-commercial Version': 'Ingyenes változat',
	"Jodit User's Guide": 'Jodit útmutató',
	'contains detailed help for using': 'további segítséget tartalmaz',
	'For information about the license, please go to our website:':
		'További licence információkért látogassa meg a weboldalunkat:',
	'Buy full version': 'Teljes verzió megvásárlása',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.',
	Anchor: 'Horgony',
	'Open in new tab': 'Megnyitás új lapon',
	'Open in fullsize': 'Megnyitás teljes méretben',
	'Clear Formatting': 'Formázás törlése',
	'Fill color or set the text color': 'Háttér/szöveg szín',
	Redo: 'Újra',
	Undo: 'Visszavon',
	Bold: 'Félkövér',
	Italic: 'Dőlt',
	'Insert Unordered List': 'Pontozott lista',
	'Insert Ordered List': 'Számozott lista',
	'Align Center': 'Középre zárt',
	'Align Justify': 'Sorkizárt',
	'Align Left': 'Balra zárt',
	'Align Right': 'Jobbra zárt',
	'Insert Horizontal Line': 'Vízszintes vonal beszúrása',
	'Insert Image': 'Kép beszúrás',
	'Insert file': 'Fájl beszúrás',
	'Insert youtube/vimeo video': 'Youtube videó beszúrása',
	'Insert link': 'Link beszúrás',
	'Font size': 'Betűméret',
	'Font family': 'Betűtípus',
	'Insert format block': 'Formázott blokk beszúrása',
	Normal: 'Normál',
	'Heading 1': 'Fejléc 1',
	'Heading 2': 'Fejléc 2',
	'Heading 3': 'Fejléc 3',
	'Heading 4': 'Fejléc 4',
	Quote: 'Idézet',
	Code: 'Kód',
	Insert: 'Beszúr',
	'Insert table': 'Táblázat beszúrása',
	'Decrease Indent': 'Behúzás csökkentése',
	'Increase Indent': 'Behúzás növelése',
	'Select Special Character': 'Speciális karakter kiválasztása',
	'Insert Special Character': 'Speciális karakter beszúrása',
	'Paint format': 'Kép formázása',
	'Change mode': 'Nézet váltása',
	Print: 'Nyomtatás',
	Margins: 'Szegélyek',
	top: 'felső',
	right: 'jobb',
	bottom: 'alsó',
	left: 'bal',
	Styles: 'CSS stílusok',
	Classes: 'CSS osztályok',
	Align: 'Igazítás',
	Right: 'Jobbra',
	Center: 'Középre',
	Left: 'Balra',
	'--Not Set--': 'Nincs',
	Src: 'Forrás',
	Title: 'Cím',
	Alternative: 'Helyettesítő szöveg',
	Link: 'Link',
	'Open link in new tab': 'Link megnyitása új lapon',
	Image: 'Kép',
	file: 'Fájl',
	'Image properties': 'Kép tulajdonságai',
	Cancel: 'Mégsem',
	Ok: 'OK',
	'Your code is similar to HTML. Keep as HTML?':
		'A beillesztett szöveg HTML-nek tűnik. Megtartsuk HTML-ként?',
	'Paste as HTML': 'Beszúrás HTML-ként',
	Keep: 'Megtartás',
	Clean: 'Elvetés',
	'Insert as Text': 'Beszúrás szövegként',
	'Word Paste Detected': 'Word-ből másolt szöveg',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'A beillesztett tartalom Microsoft Word/Excel dokumentumból származik. Meg szeretné tartani a formátumát?',
	'Insert only Text': 'Csak szöveg beillesztése',
	'File Browser': 'Fájl tallózó',
	'Error on load list': 'Hiba a lista betöltése közben',
	'Error on load folders': 'Hiba a mappák betöltése közben',
	'Are you sure?': 'Biztosan ezt szeretné?',
	'Enter Directory name': 'Írjon be egy mappanevet',
	'Create directory': 'Mappa létrehozása',
	'type name': 'írjon be bevet',
	'Drop image': 'Húzza ide a képet',
	'Drop file': 'Húzza ide a fájlt',
	'or click': 'vagy kattintson',
	'Alternative text': 'Helyettesítő szöveg',
	Browse: 'Tallóz',
	Upload: 'Feltölt',
	Background: 'Háttér',
	Text: 'Szöveg',
	Top: 'Fent',
	Middle: 'Középen',
	Bottom: 'Lent',
	'Insert column before': 'Oszlop beszúrás elé',
	'Insert column after': 'Oszlop beszúrás utána',
	'Insert row above': 'Sor beszúrás fölé',
	'Insert row below': 'Sor beszúrás alá',
	'Delete table': 'Táblázat törlése',
	'Delete row': 'Sor törlése',
	'Delete column': 'Oszlop törlése',
	'Empty cell': 'Cella tartalmának törlése',
	Delete: 'Törlés',
	'Strike through': 'Áthúzott',
	Underline: 'Aláhúzott',
	Break: 'Szünet',
	'Search for': 'Keresés',
	'Replace with': 'Csere erre',
	Replace: 'Cserélje ki',
	Edit: 'Szerkeszt',
	'Vertical align': 'Függőleges igazítás',
	'Horizontal align': 'Vízszintes igazítás',
	Filter: 'Szűrő',
	'Sort by changed': 'Rendezés módosítás szerint',
	'Sort by name': 'Rendezés név szerint',
	'Sort by size': 'Rendezés méret szerint',
	'Add folder': 'Mappa hozzáadás',
	'Split vertical': 'Függőleges felosztás',
	'Split horizontal': 'Vízszintes felosztás',
	Merge: 'Összevonás',
	'Add column': 'Oszlop hozzáadás',
	'Add row': 'Sor hozzáadás',
	Border: 'Szegély',
	'Embed code': 'Beágyazott kód',
	Update: 'Frissít',
	superscript: 'Felső index',
	subscript: 'Alsó index',
	'Cut selection': 'Kivágás',
	Paste: 'Beillesztés',
	'Choose Content to Paste': 'Válasszon tartalmat a beillesztéshez',
	Split: 'Felosztás',
	'Chars: %d': 'Karakterek száma: %d',
	'Words: %d': 'Szavak száma: %d',
	All: 'Összes',
	'Select %s': 'Kijelöl: %s',
	'Select all': 'Összes kijelölése',
	source: 'HTML',
	bold: 'Félkövér',
	italic: 'Dőlt',
	brush: 'Ecset',
	link: 'Link',
	undo: 'Visszavon',
	redo: 'Újra',
	table: 'Táblázat',
	image: 'Kép',
	eraser: 'Törlés',
	paragraph: 'Paragráfus',
	fontsize: 'Betűméret',
	video: 'Videó',
	font: 'Betű',
	about: 'Rólunk',
	print: 'Nyomtat',
	underline: 'Aláhúzott',
	strikethrough: 'Áthúzott',
	indent: 'Behúzás',
	outdent: 'Aussenseiter',
	fullsize: 'Teljes méret',
	shrink: 'Összenyom',
	hr: 'Egyenes vonal',
	ul: 'Lista',
	ol: 'Számozott lista',
	cut: 'Kivág',
	selectall: 'Összes kijelölése',
	'Open link': 'Link megnyitása',
	'Edit link': 'Link szerkesztése',
	'No follow': 'Nincs követés',
	Unlink: 'Link leválasztása',
	Eye: 'felülvizsgálat',
	pencil: 'Szerkesztés',
	' URL': 'URL',
	Reset: 'Visszaállít',
	Save: 'Mentés',
	'Save as ...': 'Mentés másként...',
	Resize: 'Átméretezés',
	Crop: 'Kivág',
	Width: 'Szélesség',
	Height: 'Magasság',
	'Keep Aspect Ratio': 'Képarány megtartása',
	Yes: 'Igen',
	No: 'Nem',
	Remove: 'Eltávolít',
	Select: 'Kijelöl',
	'You can only edit your own images. Download this image on the host?':
		'Csak a saját képeit tudja szerkeszteni. Letölti ezt a képet?',
	'The image has been successfully uploaded to the host!':
		'Kép sikeresen feltöltve!',
	palette: 'Palette',
	'There are no files': 'Er zijn geen bestanden in deze map.',
	Rename: 'átnevezés',
	'Enter new name': 'Adja meg az új nevet',
	preview: 'előnézet',
	download: 'Letöltés',
	'Paste from clipboard': 'Illessze be a vágólap',
	"Your browser doesn't support direct access to the clipboard.":
		'A böngésző nem támogatja a közvetlen hozzáférést biztosít a vágólapra.',
	'Copy selection': 'Másolás kiválasztása',
	copy: 'másolás',
	'Border radius': 'Határ sugár',
	'Show all': 'Összes',
	Apply: 'Alkalmazni',
	'Please fill out this field': 'Kérjük, töltse ki ezt a mezőt,',
	'Please enter a web address': 'Kérjük, írja be a webcímet',
	Default: 'Alapértelmezett',
	Circle: 'Kör',
	Dot: 'Pont',
	Quadrate: 'Quadrate',
	Find: 'Találni',
	'Find Previous': 'Megtalálja Előző',
	'Find Next': 'Következő Keresése',
	'Insert className': 'Helyezze be az osztály nevét',
	'Press Alt for custom resizing': 'Nyomja meg az Alt egyéni átméretezés'
};
